module.exports = __webpack_public_path__ + "img/weather_play.c868f02e.svg";